import React, { useState, useEffect, useContext } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  Snackbar,
  Alert,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  Typography,
  Box,
  DialogContentText,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { ThemeContext } from "../../../../../../../../context/ThemeContextProvider";
import { updateOrder } from "../../../../../../../../services/pos/Tables";

const EditOrderFormTableNumber = ({ open, onClose, initialData, tables }) => {
  const { mode } = useContext(ThemeContext);
  const theme = useTheme();
  const isTabletOrSmaller = useMediaQuery("(max-width:1024px)");
  const [form, setForm] = useState({});
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [selectedTable, setSelectedTable] = useState("");

  useEffect(() => {
    if (initialData) {
      setForm({
        ...initialData,
        customer_id: initialData.customer?.id ?? null, // أفضل من ""
      });
      setSelectedTable(initialData.table_id || "");
    }
  }, [initialData]);

  const handleTableChange = (e) => {
    setSelectedTable(e.target.value);
  };

  const handleConfirm = async () => {
    try {
      if (!form.order_id) throw new Error("❌ رقم الأوردر غير موجود");

      await updateOrder(form.order_id, {
        table_id: selectedTable,
        customer_id: form.customer_id,
      });

      setSuccess(true);
      setConfirmOpen(false);

      // ✨ رجع البيانات الجديدة للـ parent عشان يحدث الـ state محليًا
      onClose({
        table_id: selectedTable,
        customer_id: form.customer_id,
      });
    } catch (err) {
      setError(err.message || "❌ فشل في نقل الطاولة");
      setConfirmOpen(false);
    }
  };

  const currentTableObj = tables.find((t) => t.id === form.table_id);
  const newTableObj = tables.find((t) => t.id === selectedTable);

  return (
    <>
      <Dialog
        open={open}
        onClose={() => onClose(false)}
        fullWidth
        fullScreen={isTabletOrSmaller}
        maxWidth={false}
        PaperProps={{
          sx: {
            width: isTabletOrSmaller ? "100%" : { xs: "95%", sm: "85%", md: "60%", lg: "45%" },
            m: isTabletOrSmaller ? 0 : "auto",
            borderRadius: isTabletOrSmaller ? 0 : 3,
            p: { xs: 1, sm: 2 },
            bgcolor: mode === "dark" ? "#232334" : "#fff",
            color: mode === "dark" ? "#fff" : "#232334",
          },
        }}
      >
        <form
          onSubmit={(e) => {
            e.preventDefault();
            setConfirmOpen(true);
          }}
        >
          <DialogTitle
            sx={{
              fontWeight: 700,
              fontSize: { xs: 18, sm: 20, md: 22 },
              textAlign: "center",
              color: "#EA7C69",
              bgcolor: mode === "dark" ? "#181824" : "#fff",
              borderRadius: isTabletOrSmaller ? 0 : "16px 16px 0 0",
              py: { xs: 1, sm: 1.5 },
            }}
          >
            نقل الطاولة
          </DialogTitle>
          <DialogContent
            dividers
            sx={{
              bgcolor: mode === "dark" ? "#232334" : "#fff",
              pb: 2,
              px: { xs: 1, sm: 2, md: 3 },
            }}
          >
            <Box mb={2}>
              <Typography sx={{ fontWeight: 600, mb: 1, fontSize: { xs: 14, sm: 15 } }}>
                الطاولة الحالية:{" "}
                <span style={{ color: "#EA7C69" }}>
                  {currentTableObj?.name || form.table_id || "-"}
                </span>
              </Typography>
            </Box>
            <FormControl
              fullWidth
              sx={{
                bgcolor: mode === "dark" ? "#181824" : "#fff",
                borderRadius: 2,
              }}
            >
              <InputLabel sx={{ color: mode === "dark" ? "#aaa" : undefined, fontSize: { xs: 13, sm: 14 } }}>
                اختر الطاولة الجديدة
              </InputLabel>
              <Select
                label="اختر الطاولة الجديدة"
                name="table_id"
                value={selectedTable}
                onChange={handleTableChange}
                sx={{
                  color: mode === "dark" ? "#fff" : "#232334",
                  fontSize: { xs: 14, sm: 15 },
                  ".MuiOutlinedInput-notchedOutline": {
                    borderColor: mode === "dark" ? "#444" : "#ccc",
                  },
                  py: { xs: 0.6, sm: 1 },
                }}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      bgcolor: mode === "dark" ? "#232334" : "#fff",
                      color: mode === "dark" ? "#fff" : "#232334",
                      maxHeight: 300,
                    },
                  },
                }}
              >
                {tables && tables.length > 0 ? (
                  tables.map((table) => (
                    <MenuItem key={table.id} value={table.id} sx={{ fontSize: { xs: 14, sm: 15 } }}>
                      {table.name}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem disabled>لا توجد طاولات متاحة</MenuItem>
                )}
              </Select>
            </FormControl>
          </DialogContent>
          <DialogActions
            sx={{
              bgcolor: mode === "dark" ? "#232334" : "#fff",
              borderRadius: isTabletOrSmaller ? 0 : "0 0 16px 16px",
              flexDirection: isTabletOrSmaller ? "column-reverse" : "row",
              gap: 1,
              p: { xs: 2, sm: 2 },
            }}
          >
            <Button
              onClick={() => onClose(false)}
              variant="outlined"
              color="secondary"
              fullWidth={isTabletOrSmaller}
              sx={{
                minWidth: 100,
                borderColor: mode === "dark" ? "#888" : undefined,
                color: mode === "dark" ? "#fff" : undefined,
              }}
            >
              إلغاء
            </Button>
            <Button
              variant="contained"
              type="submit"
              disabled={!selectedTable || selectedTable === form.table_id}
              fullWidth={isTabletOrSmaller}
              sx={{
                bgcolor: "#EA7C69",
                color: "#fff",
                minWidth: 120,
                fontWeight: 700,
                fontSize: { xs: 14, sm: 15 },
                "&:hover": { bgcolor: "#d45d4c" },
              }}
            >
              نقل الطاولة
            </Button>
          </DialogActions>
        </form>
      </Dialog>

      {/* Dialog للتأكيد */}
      <Dialog
        open={confirmOpen}
        onClose={() => setConfirmOpen(false)}
        fullScreen={isTabletOrSmaller}
        maxWidth={isTabletOrSmaller ? false : "xs"}
        PaperProps={{
          sx: {
            width: isTabletOrSmaller ? "100%" : undefined,
            m: isTabletOrSmaller ? 0 : "auto",
            borderRadius: isTabletOrSmaller ? 0 : 3,
            bgcolor: mode === "dark" ? "#232334" : "#fff",
            color: mode === "dark" ? "#fff" : "#232334",
          },
        }}
      >
        <DialogTitle
          sx={{ fontWeight: 700, color: "#EA7C69", textAlign: "center", fontSize: { xs: 18, sm: 20 } }}
        >
          تأكيد نقل الطاولة
        </DialogTitle>
        <DialogContent sx={{ px: { xs: 2, sm: 3 } }}>
          <DialogContentText
            sx={{
              color: mode === "dark" ? "#fff" : "#232334",
              fontWeight: 500,
              fontSize: { xs: 14, sm: 15 },
            }}
          >
            هل أنت متأكد من نقل الطلب من الطاولة
            <span
              style={{ color: "#EA7C69", fontWeight: 700, margin: "0 6px" }}
            >
              {currentTableObj?.name || form.table_id || "-"}
            </span>
            إلى الطاولة
            <span
              style={{ color: "#EA7C69", fontWeight: 700, margin: "0 6px" }}
            >
              {newTableObj?.name || selectedTable || "-"}
            </span>
            ؟
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", pb: 2, flexDirection: isTabletOrSmaller ? "column" : "row", gap: 1 }}>
          <Button
            onClick={() => setConfirmOpen(false)}
            color="secondary"
            variant="outlined"
            fullWidth={isTabletOrSmaller}
          >
            إلغاء
          </Button>
          <Button
            onClick={handleConfirm}
            color="primary"
            variant="contained"
            sx={{ bgcolor: "#EA7C69" }}
            fullWidth={isTabletOrSmaller}
          >
            نعم، نقل الطاولة
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={!!error}
        autoHideDuration={3000}
        onClose={() => setError("")}
      >
        <Alert severity="error">{error}</Alert>
      </Snackbar>
      <Snackbar
        open={success}
        autoHideDuration={3000}
        onClose={() => setSuccess(false)}
      >
        <Alert severity="success">✅ تم نقل الطاولة بنجاح</Alert>
      </Snackbar>
    </>
  );
};

export default EditOrderFormTableNumber;
